import {
    // FILE_UPLOAD,
    CREATE_ADMIN_CUSTOM_FORMS,
    RETRIEVE_ADMIN_CUSTOM_FORMS,
    // RETRIEVE_ARCHITECTURECOMPANYCONVERTEDLEADS,
    // RETRIEVE_ARCHITECTURECOMPANYPENDINGLEADS,
    RETRIEVESINGLE_ADMIN_CUSTOM_FORMS,
    UPDATE_ADMIN_CUSTOM_FORMS,
    DELETE_ADMIN_CUSTOM_FORMS,
    // RETRIEVE_ARCHITECTURESERVERSTAFF,
    // RETRIEVE_ARCHITECTURESERVERSERVICEUSERS,
} from "./type";
import AdminCustomForms from "../service/AdminCustomForms";
// export const fileUpload = (data) => async (dispatch) => {
//   try {
//     const res = await AdminCustomForms.fileUpload(data);
//     dispatch({
//       type: FILE_UPLOAD,
//       payload: res.data.data,
//     });
//     return Promise.resolve(res.data);
//   } catch (err) {
//     return Promise.reject(err);
//   }
// };
export const create = (data) => async (dispatch) => {
    try {
        const res = await AdminCustomForms.create(data);
        dispatch({
            type: CREATE_ADMIN_CUSTOM_FORMS,
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const retrieve = (data) => async (dispatch) => {
    try {
        const res = await AdminCustomForms.fetchList(data);
        dispatch({
            type: RETRIEVE_ADMIN_CUSTOM_FORMS,
            status: '',
            response: {},
            payload: res.data.data,
        });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const retrieveSingle = (data) => async (dispatch) => {
    try {
        const res = await AdminCustomForms.fetchSingle(data);
        // dispatch({
        //     type: RETRIEVESINGLE_ADMIN_CUSTOM_FORMS,
        //     status: '',
        //     response: {},
        //     payload: res.data.data,
        // });
        return Promise.resolve(res.data.data);
    } catch (err) {
        console.log(err);
        return Promise.reject(err);
    }
};
export const update = (data) => async (dispatch) => {
    try {
        const res = await AdminCustomForms.update(data);
        dispatch({
            type: UPDATE_ADMIN_CUSTOM_FORMS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};
// export const changeStatus = (data) => async (dispatch) => {
//     try {
//         const res = await AdminCustomForms.changeStatus(data);
//         dispatch({
//             type: UPDATE_ADMIN_CUSTOM_FORMS,
//             status: '',
//             response: {},
//             payload: res.data,
//         });
//         return Promise.resolve(res.data);
//     } catch (err) {
//         return Promise.reject(err);
//     }
// };
export const trash = (data) => async (dispatch) => {
    try {
        const res = await AdminCustomForms.trash(data);
        dispatch({
            type: DELETE_ADMIN_CUSTOM_FORMS,
            status: '',
            response: {},
            payload: res.data,
        });
        return Promise.resolve(res.data);
    } catch (err) {
        return Promise.reject(err);
    }
};